import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  iconError: {
    marginRight: "5px",
    fontSize: "16px",
  },
  flagInput: {
    marginLeft: "10px",
  },
  flagSelect: {
    marginLeft: "2px",
  },
  flag: {
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    gap: "10px",
  },
}));

export default styles;
